import { Logo } from '@/assets/logo';

export function LoadingScreen() {
  return (
    <div className="flex flex-col items-center justify-center mt-[6rem]">
      <Logo className="h-24 mb-6 animate-bounce" />
      <div className="relative">
        <div className="h-2 w-32 bg-gray-200 rounded-lg overflow-hidden">
          <div className="h-full bg-primary rounded-lg animate-progress" />
        </div>
      </div>
    </div>
  );
}